import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostUpdateStatus = (params) => {
    return async (dispatch, getState) => {
        try {
            DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_GAME_FS
            });
            alert('статус обновлен')
            dispatch(Action.SetGetViewGameFreespin({
                id: params.id
            }))
        } catch (error) {
            //todo доделать catch 
            alert('Ошибка обновления')
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateStatus as SetPostUpdateStatus
}